import Vue from 'vue';
import VuePageTitle from 'vue-page-title';
import App from './App.vue';
import router from './router';
import store from './store';
import NProgress from 'vue-nprogress';
import '@/directive';
import filters from '@/filters';
import i18n from '@/locales';
import VueLayers from 'vuelayers';
import BootstrapVue from 'bootstrap-vue';
import VueSignaturePad from 'vue-signature-pad';
import Router from 'vue-router';
import {
  Avatar,
  Breadcrumb,
  InputNumber,
  Steps,
  Message,
  Upload,
  Button,
  Layout,
  Table,
  Icon,
  Progress,
  Radio,
  Dropdown,
  Menu,
  Carousel,
  Input,
  Calendar,
  Badge,
  Slider,
  Form,
  Tooltip,
  Select,
  Switch,
  Tag,
  Affix,
  Spin,
  Alert,
  Checkbox,
  Tabs,
  Pagination,
  notification,
  Drawer,
  Descriptions,
  Cascader,
  DatePicker,
  TimePicker,
  Divider,
  Anchor,
  AutoComplete,
  BackTop,
  Collapse,
  Card,
  Row,
  Col,
  Transfer,
  Modal,
  message,
  LocaleProvider,
  Popconfirm,
  Popover,
  Result,
  List,
} from 'ant-design-vue';

import { InlineSvgPlugin } from 'vue-inline-svg';

import './global.scss';
import wysiwyg from 'vue-wysiwyg';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import { includes } from 'lodash';

Vue.use(wysiwyg, {
  hideModules: { table: true },
  forcePlainTextOnPaste: true,
});
Vue.use(VueSignaturePad);

Vue.use(BootstrapVue);
Vue.use(VueLayers);
Vue.use(Avatar);
Vue.use(Transfer);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(Layout);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Calendar);
Vue.use(Badge);
Vue.use(Slider);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Tag);
Vue.use(Affix);
Vue.use(Spin);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(Message);
Vue.use(Steps);
Vue.use(InputNumber);
Vue.use(Drawer);
Vue.use(Descriptions);
Vue.use(Switch);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Anchor);
Vue.use(AutoComplete);
Vue.use(Collapse);
Vue.use(Popover);
Vue.use(Result);
Vue.use(List);
Vue.use(BackTop);
Vue.use(LocaleProvider);
Vue.use(CoolLightBox);
Vue.use(InlineSvgPlugin);
Vue.use(filters);

Vue.prototype.$notification = notification;
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$error = Modal.error;
Vue.prototype.$success = Modal.success;

Vue.use(NProgress);
Vue.use(VuePageTitle, {
  prefix: 'TrueLife.org | ',
  router,
});

// https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

Vue.mixin({
  computed: {
    isAdmin() {
      const userRole = store.state.user.user.role;
      return includes(userRole, 'admin');
    },
    isPastor() {
      const userRole = store.state.user.user.role;
      return includes(userRole, 'evangelism');
    },
    isIndividual() {
      const userRole = store.state.user.user.role;
      return includes(userRole, 'individual');
    },
  },
  methods: {
    instructionVideo(slug) {
      const video = store.state.settings.instructionVideos.find(v => v.slug === slug);
      return video && video.url;
    },
  },
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ziggeorecorder/, /^ziggeoplayer/];
const nprogress = new NProgress({ parent: 'body' });
new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app');
